import { Alert } from '@material-ui/lab';
import { ChevronRightRounded } from '@material-ui/icons';
import { Box, Button, Typography } from '@material-ui/core';

import { getDropdownActions } from './utils';
import { useHeaderLang } from './hooks/useHeaderLang';

import useHeaderStyles from './header.styles';

export function CargoDropDownContent(props: { isEnabled: boolean }) {
  const { isEnabled } = props;

  const options = getDropdownActions();

  const styles = useHeaderStyles();

  const {
    infoTitleText,
    infoTitleDescriptionText,
    bannerWhenIsDisabledP1Text,
    bannerWhenIsDisabledP2Text,
  } = useHeaderLang();

  return (
    <Box
      className={styles.dropDownContainer}
      display={'flex'}
      flexDirection={'column'}
      gridGap={'1rem'}
      padding={'1.5rem'}
      minWidth={'23.5rem'}
    >
      <Box display={'flex'} flexDirection='column'>
        <Typography component='h4' className={styles.dropDownInfoTitle}>
          {infoTitleText}
        </Typography>
        <Typography component='p' className={styles.dropDownInfoDescription}>
          {infoTitleDescriptionText}
        </Typography>
      </Box>

      <div className={styles.divider} />

      {!isEnabled && (
        <Alert role='alert' severity='info' classes={{ root: styles.banner }}>
          {bannerWhenIsDisabledP1Text}
          <a target='_blank' href='https://partners.rappi.com/cargo/home'>
            {bannerWhenIsDisabledP2Text}
          </a>
        </Alert>
      )}

      {options.map((option, idx) => (
        <Button
          key={`crg-act-${idx}`}
          onClick={option.action}
          disabled={option.matchWithIsEnabled && !isEnabled}
          startIcon={<option.icon fill='inherit' />}
          endIcon={<ChevronRightRounded />}
          classes={{
            root: styles.dropDownActionContentBtnRoot,
            label: styles.dropDownActionContentBtnContainer,
          }}
        >
          <Box flex={1}>
            <Typography component='h5' className={styles.dropDownActionTitle}>
              {option.title}
            </Typography>
            <Typography
              component='span'
              className={styles.dropDownActionDescription}
            >
              {option.description}
            </Typography>
          </Box>
        </Button>
      ))}
    </Box>
  );
}
